import { 
  createSliceLayout,
  SliceColorStrip,
  SliceColorStripProps,
  SliceContactForm,
  SliceContactFormProps,
  SliceContentEntityQuote,
  SliceHeaderDivider,
  SliceHeaderDividerProps,
  SliceModalButton,
  SliceModalButtonProps,
  SlicePersonBioGrid,
  SlicePersonBioGridProps,
} from '@shapeable/ui';
import { CONFERANCE_COLORS } from '../../theme';
import { ContactUsIframeEmbed } from '../elements/contact-us-iframe-embed';

export const SliceLayoutHeader = createSliceLayout<SliceHeaderDividerProps>(
  SliceHeaderDivider, {
    boundary: 'content',
    props: {
    }
  }
);

export const SliceLayoutKeyMessage = createSliceLayout(
  SliceContentEntityQuote, {
    boundary: 'none',
    themeMode: 'dark',
  }
);

export const SliceLayoutColorStrip = createSliceLayout<SliceColorStripProps>(
  SliceColorStrip, {
    boundary: 'none',
    props: {
      colors: CONFERANCE_COLORS
    }
  }
);

export const SliceLayoutContactForm = createSliceLayout<SliceContactFormProps>(
  SliceContactForm, {
    props: {
      variant: 'reveal',
    }
  }
);

export const SliceLayoutPeople = createSliceLayout<SlicePersonBioGridProps>(
  SlicePersonBioGrid, {
    verticalPadding: 'small',
    props: {
      transform: 'grayscale',
      showOrganisation: true,
    }
  }
); 

export const SliceLayoutModalButton = createSliceLayout<SliceModalButtonProps>(
  SliceModalButton, {
    boundary: 'none',
    verticalPadding: 'content',
    props: {
      modalLayout: ContactUsIframeEmbed,
      label: "Show contact us form",
    }
  }
);